'use client';


import { useEffect, useState } from 'react';

// hook to easily fetch whether iSPAI is running in reduced functionality mode, due to a running on a
// device that doesn't support recording and speech recognition.

// Hook is useful because browser features can only be accessed via useEffect when running on a next server....

export const useIsUnsupported = () => {
    const [isUnsupported, setIsUnsupported] = useState<boolean | undefined>();

    useEffect(() => {
        setIsUnsupported(window.localStorage.getItem('isUnsupported') === 'true');
    }, [setIsUnsupported]);



    return { isUnsupported };
}